import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Col, Row, Container, Image } from "react-bootstrap";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRightLong,
  faArrowLeftLong,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { cityImages } from "../Shared/OurTeamData";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const FlightFrom = () => {
  const [selectedCity, setSelectedCity] = useState("Delhi");
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const sliderRef = useRef(null);

  const handleSlideChange = () => {
    if (sliderRef.current) {
      const swiperInstance = sliderRef.current.swiper;
      setIsBeginning(swiperInstance.isBeginning);
      setIsEnd(swiperInstance.isEnd);
    }
  };
  return (
    <>
      <Box className="flightFrom py-5">
        <Container>
          <Row>
            <Col lg={3} className="sliderInfo">
              <motion.div
                initial={{ opacity: 0.5, x: -250 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.9, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Typography variant="h2">
                  Popular Trending Destinations
                </Typography>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth className="cstMaterialDrop">
                    <InputLabel id="changeSliderCities">Select</InputLabel>
                    <Select
                      disabled
                      labelId="changeSliderCities"
                      id="citySelect"
                      value={selectedCity}
                      label="Select"
                      onChange={(e) => setSelectedCity(e.target.value)}
                    >
                      {Object.keys(cityImages).map((city) => (
                        <MenuItem
                          className="cstDeropOptions"
                          key={city}
                          value={city}
                        >
                          {city}
                        </MenuItem>
                      ))}
                    </Select>
                    <Typography variant="body1" component="p">
                            Our route network connects diverse regions across India—supporting mobility, opportunity, and exploration. Wherever you're headed, we’re here to make the journey smoother.
                    </Typography>
                  </FormControl>
                  <Box className="cstSwiperSlider">
                    <button
                      onClick={() => sliderRef.current.swiper.slidePrev()}
                      disabled={isBeginning}
                      className="custom-prev"
                    >
                      <FontAwesomeIcon icon={faArrowLeftLong} />
                    </button>
                    <button
                      onClick={() => sliderRef.current.swiper.slideNext()}
                      disabled={isEnd}
                      className="custom-next"
                    >
                      <FontAwesomeIcon icon={faArrowRightLong} />
                    </button>
                  </Box>
                </Box>
              </motion.div>
            </Col>
            <Col lg={9} className="sliderWrapper">
              <motion.div
                initial={{ opacity: 0.5, x: 250 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.9, ease: "easeInOut" }}
                viewport={{ once: true }}
              >
                <Swiper
                  ref={sliderRef}
                  modules={[Navigation, Pagination, Scrollbar, A11y]}
                  onSlideChange={handleSlideChange}
                  onSwiper={(swiper) => {
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                  }}
                  navigation={true}
                  loop={false}
                  spaceBetween={15}
                  slidesPerView={2}
                  breakpoints={{
                    320: {
                      slidesPerView: 1,
                    },
                    640: {
                      slidesPerView: 1,
                    },
                    980: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="city-slider"
                >
                  {cityImages[selectedCity].map((image, index) => (
                    <SwiperSlide key={index} className="singleSlide">
                      <Image
                        src={image.src}
                        alt={image.title}
                        className="img-fluid"
                      />
                      <Box className="sliderOverlay"></Box>
                      <Box className="slideImgContent">
                        <Box>
                          <Typography variant="body1" component="p">
                            {image.title}
                          </Typography>
                          <Typography variant="body1" component="span">
                            {/* Deaprture 16:50 */}
                            Most Affordable Fares
                          </Typography>
                        </Box>
                        <button className="btnhoverChange">
                          <span class="text">Learn More</span>
                          {/* <span class="text">Book Now</span> */}
                          <span>Explore</span>
                        </button>
                        {/* <button>{image.btnText}</button> */}
                      </Box>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default FlightFrom;
